import React from "react";

const QueryType = {
  ALL: "ALL",
  PATENT: "PATENT",
  PUBLICATION: "PUBLICATION",
};

const QueryTypeLabel = {
  ALL: "All",
  PATENT: "Patents",
  PUBLICATION: "Publications",
};

const DataSource = {
  uspto: "uspto",
  patstat: "patstat",
  mag: "mag",
  springer: "springer",
};

const DataSourceLabel = {
  uspto: <abbr title="United States Patent and Trademark Office">USPTO</abbr>,
  patstat: (
    <abbr title="Worldwide Patent Statistical Database by European Patent Office">
      PATSTAT
    </abbr>
  ),
  mag: <abbr title="Microsoft Academic Graph">MAG</abbr>,
  springer: "Springer",
};

const DataSourceIcons = {
  uspto: "flag-usa",
  patstat: "fingerprint",
  mag: "microsoft",
  springer: "chess-knight",
};

const DataSourceByQueryType = {
  ALL: [
    DataSource.uspto,
    DataSource.patstat,
    DataSource.mag,
    DataSource.springer,
  ],
  PATENT: [DataSource.uspto, DataSource.patstat],
  PUBLICATION: [DataSource.mag, DataSource.springer],
};

const QueryFields = {
  None: 0,
  PatentNumber: 1,
  Title: 1 << 1,
  Abstract: 1 << 2,
  Year: 1 << 3,
  Date: 1 << 4,
  Authors: 1 << 5,
  Author: 1 << 6,
  Owners: 1 << 7,
  Owner: 1 << 8,
  DataSource: 1 << 9,
  Publisher: 1 << 10,
  FOS: 1 << 11,
  Issue: 1 << 12,
  Url: 1 << 13,
  Keywords: 1 << 14,
  Venue: 1 << 15,
  Language: 1 << 16,
  DOI: 1 << 17,
  Status: 1 << 18,
  Country: 1 << 19,
  Claims: 1 << 20,
  IPC: 1 << 21,
  CPC: 1 << 22,
};
QueryFields.Default =
  QueryFields.Title | QueryFields.Abstract | QueryFields.Author;
QueryFields.ALL =
  QueryFields.Default | QueryFields.Language | QueryFields.DataSource;
QueryFields.PATENT =
  QueryFields.ALL |
  QueryFields.PatentNumber |
  QueryFields.Date |
  QueryFields.Owner |
  QueryFields.Country |
  QueryFields.Status /** | // Disabled Claims #248
  QueryFields.Claims /** | // Disabled CPC/IPC #242
  QueryFields.IPC /** | // Disabled CPC/IPC #242
  QueryFields.CPC /**/;
QueryFields.PUBLICATION =
  QueryFields.ALL |
  QueryFields.Year |
  QueryFields.Publisher |
  QueryFields.FOS |
  QueryFields.Keywords |
  QueryFields.Issue |
  QueryFields.Url |
  QueryFields.DOI |
  QueryFields.Venue;

const StatusType = {
  None: 0,
  Queried: 1,
  Modified: 1 << 1,
  Result: 1 << 2,
  Append: 1 << 3,
  Querying: 1 << 4,
};

const ResponseType = {
  FILE: "FILE",
  PATENT: "PATENT",
  PUBLICATION: "PUBLICATION",
  WIKI: "WIKI",
  GOOGLE: "GOOGLE",
};

const ResponseTypeLabel = {
  FILE: "Upload",
  PATENT: "Patent",
  PUBLICATION: "Publication",
  WIKI: "Wikipedia",
  GOOGLE: "Google",
};

const ResponseTypeIcons = {
  PATENT: "registered",
  FILE: "file-upload",
  PUBLICATION: "newspaper",
  GOOGLE: "google",
  WIKI: "wikipedia-w",
};

const AlertType = {
  Success: "Success",
  Error: "Error",
  Info: "Info",
  Warning: "Warning",
};

const RegExFileExtension = /(?:\.([^.]+))?$/;
const ImageFileExtensions = [".jpg", ".jpeg", ".png", ".gif"];

export {
  QueryType,
  QueryTypeLabel,
  DataSource,
  DataSourceLabel,
  DataSourceIcons,
  DataSourceByQueryType,
  QueryFields,
  StatusType,
  ResponseType,
  ResponseTypeLabel,
  ResponseTypeIcons,
  AlertType,
  RegExFileExtension,
  ImageFileExtensions,
};
